var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.569,3.22,21.22,4.871,13.871,12.22l7.349,7.349L19.569,21.22,12.22,13.871,4.871,21.22,3.22,19.569l7.349-7.349L3.22,4.871,4.871,3.22l7.349,7.349L19.569,3.22Z",
    transform: "translate(-3.22 -3.22)",
    fill: "#fff"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4NCiAgPHBhdGggZD0iTTE5LjU2OSwzLjIyLDIxLjIyLDQuODcxLDEzLjg3MSwxMi4yMmw3LjM0OSw3LjM0OUwxOS41NjksMjEuMjIsMTIuMjIsMTMuODcxLDQuODcxLDIxLjIyLDMuMjIsMTkuNTY5bDcuMzQ5LTcuMzQ5TDMuMjIsNC44NzEsNC44NzEsMy4yMmw3LjM0OSw3LjM0OUwxOS41NjksMy4yMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjIyIC0zLjIyKSIgZmlsbD0iI2ZmZiIvPg0KPC9zdmc+DQo=";
export { SvgCloseWhite as ReactComponent };